import { Outlet } from "react-router-dom";

const ExternalServicesOutlet = () => {
  return <Outlet />;
};

export { ExternalServicesOutlet };
